import { Link } from '@/components/Link';
import { cx } from '@/util/cx';
import { RouteType } from '@/util/routeToPath';
import { ComponentProps } from 'react';
import styles from './BackLink.module.scss';

type Props = {
  to: RouteType;
  title?: string;
  onClick?: ComponentProps<'a'>['onClick'];
  hidden?: 'md' | 'lg' | 'xl';
};

export function BackLink({
  to,
  title = 'Naar overzicht',
  onClick,
  hidden,
}: Props) {
  return (
    <div className={cx(styles.BackLink, hidden && styles[`hidden-${hidden}`])}>
      <Link
        iconSize={2}
        to={to}
        underline
        icon="chevron_left_narrow"
        onClick={onClick}
      >
        {title}
      </Link>
    </div>
  );
}
